import { render } from "./base-dialog-card_rename.vue?vue&type=template&id=086531fa&ts=true"
import script from "./base-dialog-card_rename.vue?vue&type=script&lang=ts"
export * from "./base-dialog-card_rename.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__